<template>
  <v-form v-model="valid" ref="mainForm">
    <CarteIdentification :identification="identification" class="mb-6" showDateNaissance showSexe />
  </v-form>
</template>

<script>
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CarteIdentification from "@/components/form_parts/CarteIdentification.vue"

export default {
  components: { CarteIdentification },
  mixins: [CataloguesHelpers, StepFormWithValidation],
  props: {
    sas: { type: Object }
  },
  computed: {
    identification() {
      return this.sas.identification
    }
  }
}
</script>

<style></style>
